import { FaStar, FaUsers } from 'react-icons/fa';
import { FaRegClone, FaRegFileLines } from 'react-icons/fa6';
import { RiTimerLine } from 'react-icons/ri';
import course01 from '../../../../Images/Course/course-1.jpg';
import course05 from '../../../../Images/Course/course-10.jpg';
import course02 from '../../../../Images/Course/course-2.jpg';
import course03 from '../../../../Images/Course/course-3.jpg';
import course04 from '../../../../Images/Course/course-4.jpg';
import course06 from '../../../../Images/Course/course-6.jpg';
import './RecordCourseCard.css';

const LevelTwo = () => {
  return (
    <section className='kits-course'>
      <div className='container px-6 py-10 mx-auto'>
        <div className='grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3'>
          <div className='bg-white rounded-[10px] border border-[#E0E5EB] pt-[20px] transition-transform duration-300 hover:-translate-y-[8px]'>
            <div className='px-[20px]'>
              <div className='w-full h-auto overflow-hidden rounded-[10px]'>
                <img
                  className=' w-full h-full object-cover'
                  src={course01}
                  alt='icons'
                />
              </div>
            </div>
            <div className='p-[20px] mb-[10px]'>
              <h4 className='text-[20px] leading-7 font-semibold mb-[15px] hover:text-primary transition-all duration-300 ease-in-out'>
                <a href='#'>Welding 1G to 4G </a>
              </h4>
              <div className='flex items-center justify-between'>
                <div>
                  <h3>
                    <span className='text-primary font-semibold text-[17px]'>
                      ৳ 70,000
                    </span>
                    <del className='ml-3 font-medium text-[15px] text-neutral-600'>
                      ৳ 90,000
                    </del>
                  </h3>
                </div>
                <div className='flex items-center gap-1.5'>
                  <FaStar className='text-[#ffc000]' />
                  <span className='text-[#162726] text-[15px] font-medium'>
                    4.5(50)
                  </span>
                </div>
              </div>
              <div className='flex items-center gap-3 mt-[15px] justify-between'>
                <div className='flex items-center gap-1.5'>
                  <FaRegFileLines className='text-[#6C706F]' />

                  <span className='text-[#6C706F] text-[14px] font-medium'>
                    Class - 50
                  </span>
                </div>
                <div className='flex items-center gap-1.5 '>
                  <RiTimerLine className='text-[#6C706F]' />
                  <span className='text-[#6C706F] text-[14px] font-medium'>
                    Duration - 6 Month
                  </span>
                </div>
              </div>
              <div className='flex items-center gap-3 mt-[10px] justify-between'>
                <div className='flex items-center gap-1.5'>
                  <FaRegClone className='text-[#6C706F]' />

                  <span className='text-[#6C706F] text-[14px] font-medium'>
                    Projects - 10+
                  </span>
                </div>
                <div className='flex items-center gap-1.5 '>
                  <FaUsers className='text-[#6C706F]' />
                  <span className='text-[#6C706F] text-[14px] font-medium'>
                    Student Joined - 230
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className='bg-white rounded-[10px] border border-[#E0E5EB] pt-[20px] transition-transform duration-300 hover:-translate-y-[8px]'>
            <div className='px-[20px]'>
              <div className='w-full h-auto overflow-hidden rounded-[10px]'>
                <img
                  className=' w-full h-full object-cover'
                  src={course02}
                  alt='icons'
                />
              </div>
            </div>
            <div className='p-[20px] mb-[10px]'>
              <h4 className='text-[20px] leading-7 font-semibold mb-[15px] hover:text-primary transition-all duration-300 ease-in-out'>
                <a href='#'>Welding 4G to 6G + TIG</a>
              </h4>
              <div className='flex items-center justify-between'>
                <div>
                  <h3>
                    <span className='text-primary font-semibold text-[17px]'>
                      ৳ 30,000
                    </span>
                    <del className='ml-3 font-medium text-[15px] text-neutral-600'>
                      ৳ 40,000
                    </del>
                  </h3>
                </div>
                <div className='flex items-center gap-1.5'>
                  <FaStar className='text-[#ffc000]' />
                  <span className='text-[#162726] text-[15px] font-medium'>
                    4.9(30)
                  </span>
                </div>
              </div>
              <div className='flex items-center gap-3 mt-[15px] justify-between'>
                <div className='flex items-center gap-1.5'>
                  <FaRegFileLines className='text-[#6C706F]' />

                  <span className='text-[#6C706F] text-[14px] font-medium'>
                    Class - 20
                  </span>
                </div>
                <div className='flex items-center gap-1.5 '>
                  <RiTimerLine className='text-[#6C706F]' />
                  <span className='text-[#6C706F] text-[14px] font-medium'>
                    Duration - 3 Month
                  </span>
                </div>
              </div>
              <div className='flex items-center gap-3 mt-[10px] justify-between'>
                <div className='flex items-center gap-1.5'>
                  <FaRegClone className='text-[#6C706F]' />

                  <span className='text-[#6C706F] text-[14px] font-medium'>
                    Projects - 05+
                  </span>
                </div>
                <div className='flex items-center gap-1.5 '>
                  <FaUsers className='text-[#6C706F]' />
                  <span className='text-[#6C706F] text-[14px] font-medium'>
                    Student Joined - 30
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className='bg-white rounded-[10px] border border-[#E0E5EB] pt-[20px] transition-transform duration-300 hover:-translate-y-[8px]'>
            <div className='px-[20px]'>
              <div className='w-full h-auto overflow-hidden rounded-[10px]'>
                <img
                  className=' w-full h-full object-cover'
                  src={course03}
                  alt='icons'
                />
              </div>
            </div>
            <div className='p-[20px] mb-[10px]'>
              <h4 className='text-[20px] leading-7 font-semibold mb-[15px] hover:text-primary transition-all duration-300 ease-in-out'>
                <a href='#'>1G to TIG Complete</a>
              </h4>
              <div className='flex items-center justify-between'>
                <div>
                  <h3>
                    <span className='text-primary font-semibold text-[17px]'>
                      ৳ 50,000
                    </span>
                    <del className='ml-3 font-medium text-[15px] text-neutral-600'>
                      ৳ 60,000
                    </del>
                  </h3>
                </div>
                <div className='flex items-center gap-1.5'>
                  <FaStar className='text-[#ffc000]' />
                  <span className='text-[#162726] text-[15px] font-medium'>
                    4.2(80)
                  </span>
                </div>
              </div>
              <div className='flex items-center gap-3 mt-[15px] justify-between'>
                <div className='flex items-center gap-1.5'>
                  <FaRegFileLines className='text-[#6C706F]' />

                  <span className='text-[#6C706F] text-[14px] font-medium'>
                    Class - 22
                  </span>
                </div>
                <div className='flex items-center gap-1.5 '>
                  <RiTimerLine className='text-[#6C706F]' />
                  <span className='text-[#6C706F] text-[14px] font-medium'>
                    Duration - 4 Month
                  </span>
                </div>
              </div>
              <div className='flex items-center gap-3 mt-[10px] justify-between'>
                <div className='flex items-center gap-1.5'>
                  <FaRegClone className='text-[#6C706F]' />

                  <span className='text-[#6C706F] text-[14px] font-medium'>
                    Projects - 10+
                  </span>
                </div>
                <div className='flex items-center gap-1.5 '>
                  <FaUsers className='text-[#6C706F]' />
                  <span className='text-[#6C706F] text-[14px] font-medium'>
                    Student Joined - 230
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className='bg-white rounded-[10px] border border-[#E0E5EB] pt-[20px] transition-transform duration-300 hover:-translate-y-[8px]'>
            <div className='px-[20px]'>
              <div className='w-full h-auto overflow-hidden rounded-[10px]'>
                <img
                  className=' w-full h-full object-cover'
                  src={course04}
                  alt='icons'
                />
              </div>
            </div>
            <div className='p-[20px] mb-[10px]'>
              <h4 className='text-[20px] leading-7 font-semibold mb-[15px] hover:text-primary transition-all duration-300 ease-in-out'>
                <a href='#'>1G to 6G + MIG</a>
              </h4>
              <div className='flex items-center justify-between'>
                <div>
                  <h3>
                    <span className='text-primary font-semibold text-[17px]'>
                      ৳ 25,000
                    </span>
                    <del className='ml-3 font-medium text-[15px] text-neutral-600'>
                      ৳ 35,000
                    </del>
                  </h3>
                </div>
                <div className='flex items-center gap-1.5'>
                  <FaStar className='text-[#ffc000]' />
                  <span className='text-[#162726] text-[15px] font-medium'>
                    5.0(26)
                  </span>
                </div>
              </div>
              <div className='flex items-center gap-3 mt-[15px] justify-between'>
                <div className='flex items-center gap-1.5'>
                  <FaRegFileLines className='text-[#6C706F]' />

                  <span className='text-[#6C706F] text-[14px] font-medium'>
                    Class - 10
                  </span>
                </div>
                <div className='flex items-center gap-1.5 '>
                  <RiTimerLine className='text-[#6C706F]' />
                  <span className='text-[#6C706F] text-[14px] font-medium'>
                    Duration - 6 Month
                  </span>
                </div>
              </div>
              <div className='flex items-center gap-3 mt-[10px] justify-between'>
                <div className='flex items-center gap-1.5'>
                  <FaRegClone className='text-[#6C706F]' />

                  <span className='text-[#6C706F] text-[14px] font-medium'>
                    Projects - 06+
                  </span>
                </div>
                <div className='flex items-center gap-1.5 '>
                  <FaUsers className='text-[#6C706F]' />
                  <span className='text-[#6C706F] text-[14px] font-medium'>
                    Student Joined - 1200
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className='bg-white rounded-[10px] border border-[#E0E5EB] pt-[20px] transition-transform duration-300 hover:-translate-y-[8px]'>
            <div className='px-[20px]'>
              <div className='w-full h-auto overflow-hidden rounded-[10px]'>
                <img
                  className=' w-full h-full object-cover'
                  src={course06}
                  alt='icons'
                />
              </div>
            </div>
            <div className='p-[20px] mb-[10px]'>
              <h4 className='text-[20px] leading-7 font-semibold mb-[15px] hover:text-primary transition-all duration-300 ease-in-out'>
                <a href='#'>Pipe Fitter, Plumber</a>
              </h4>
              <div className='flex items-center justify-between'>
                <div>
                  <h3>
                    <span className='text-primary font-semibold text-[17px]'>
                      ৳ 25,000
                    </span>
                    <del className='ml-3 font-medium text-[15px] text-neutral-600'>
                      ৳ 35,000
                    </del>
                  </h3>
                </div>
                <div className='flex items-center gap-1.5'>
                  <FaStar className='text-[#ffc000]' />
                  <span className='text-[#162726] text-[15px] font-medium'>
                    5.0(26)
                  </span>
                </div>
              </div>
              <div className='flex items-center gap-3 mt-[15px] justify-between'>
                <div className='flex items-center gap-1.5'>
                  <FaRegFileLines className='text-[#6C706F]' />

                  <span className='text-[#6C706F] text-[14px] font-medium'>
                    Class - 13
                  </span>
                </div>
                <div className='flex items-center gap-1.5 '>
                  <RiTimerLine className='text-[#6C706F]' />
                  <span className='text-[#6C706F] text-[14px] font-medium'>
                    Duration - 2 Month
                  </span>
                </div>
              </div>
              <div className='flex items-center gap-3 mt-[10px] justify-between'>
                <div className='flex items-center gap-1.5'>
                  <FaRegClone className='text-[#6C706F]' />

                  <span className='text-[#6C706F] text-[14px] font-medium'>
                    Projects - 03+
                  </span>
                </div>
                <div className='flex items-center gap-1.5 '>
                  <FaUsers className='text-[#6C706F]' />
                  <span className='text-[#6C706F] text-[14px] font-medium'>
                    Student Joined - 150
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className='bg-white rounded-[10px] border border-[#E0E5EB] pt-[20px] transition-transform duration-300 hover:-translate-y-[8px]'>
            <div className='px-[20px]'>
              <div className='w-full h-auto overflow-hidden rounded-[10px]'>
                <img
                  className=' w-full h-full object-cover'
                  src={course05}
                  alt='icons'
                />
              </div>
            </div>
            <div className='p-[20px] mb-[10px]'>
              <h4 className='text-[20px] leading-7 font-semibold mb-[15px] hover:text-primary transition-all duration-300 ease-in-out'>
                <a href='#'>Shuttering Carpenter</a>
              </h4>
              <div className='flex items-center justify-between'>
                <div>
                  <h3>
                    <span className='text-primary font-semibold text-[17px]'>
                      ৳ 25,000
                    </span>
                    <del className='ml-3 font-medium text-[15px] text-neutral-600'>
                      ৳ 35,000
                    </del>
                  </h3>
                </div>
                <div className='flex items-center gap-1.5'>
                  <FaStar className='text-[#ffc000]' />
                  <span className='text-[#162726] text-[15px] font-medium'>
                    5.0(26)
                  </span>
                </div>
              </div>
              <div className='flex items-center gap-3 mt-[15px] justify-between'>
                <div className='flex items-center gap-1.5'>
                  <FaRegFileLines className='text-[#6C706F]' />

                  <span className='text-[#6C706F] text-[14px] font-medium'>
                    Class - 10
                  </span>
                </div>
                <div className='flex items-center gap-1.5 '>
                  <RiTimerLine className='text-[#6C706F]' />
                  <span className='text-[#6C706F] text-[14px] font-medium'>
                    Duration - 6 Month
                  </span>
                </div>
              </div>
              <div className='flex items-center gap-3 mt-[10px] justify-between'>
                <div className='flex items-center gap-1.5'>
                  <FaRegClone className='text-[#6C706F]' />

                  <span className='text-[#6C706F] text-[14px] font-medium'>
                    Projects - 04+
                  </span>
                </div>
                <div className='flex items-center gap-1.5 '>
                  <FaUsers className='text-[#6C706F]' />
                  <span className='text-[#6C706F] text-[14px] font-medium'>
                    Student Joined - 23
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LevelTwo;
